module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAiCAMAAAB/VplGAAAAM1BMVEV7Y/96Y/97Yv96Yv95Yv97Y/97Y/97Yv9HcEx7Y/97Y/97Yv98Y/96YP97Yv97Yv97Y/87k5V2AAAAEXRSTlP/ekSsG/PV7QDmssJJMV+Hnr9KvFcAAACNSURBVDjLvdHBDsMgCIBhdAJSVPr+TzuPpU6yZM3+9PYdCghDeRsNUAgiwIgROGJ+gvl4uciz9uJK6FgsXTP1DOjiRyf/kcWFN6aRL7UTw7PYjZFc8s/FWJe33EzeZOW5d2tz4fkZf/g3rxf7YjSJmWI+QpYR8lki1l73jJprBdpcm6zXyYlkjdRymVrfNOcIKO9VNtIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon_model.png
// module id = VUeA
// module chunks = 1